module.exports = __webpack_public_path__ + "static/media/duplicate-button.bf69b9a8.svg";